const container = document.getElementById("dashboard-content");
const loading = document.getElementById("dashboard-loading");

async function loadDashboard() {
  if (!container || !loading) return;

  try {
    const response = await fetch(
      "https://api.goprovalo.com/get_customer_dashboard.php",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      }
    );

    const responseText = await response.text();
    let data;

    try {
      data = JSON.parse(responseText);
    } catch (error) {
      console.error(
        "Invalid dashboard API response:",
        responseText
      );

      throw new Error(
        "The dashboard service returned an invalid response."
      );
    }

    if (
      response.status === 401 ||
      data.error === "customer_not_authenticated"
    ) {
      window.location.href =
        "https://api.goprovalo.com/auth/" +
        "shopify_customer_login.php" +
        "?return=%2Fpages%2Fmy-account";

      return;
    }

  if (!response.ok || !data.success) {
    loading.textContent =
      data.message || "Unable to load dashboard.";

    return;
  }

    renderDashboard(data);
  } catch (error) {
    console.error("Dashboard loading error:", error);
    loading.textContent =
      "Unable to connect to the server.";
  }
}

function renderDashboard(data) {
  loading.style.display = "none";
  container.style.display = "block";

  const recentDownloads =
    data.recent_downloads || [];

  const savedProperties =
    data.saved_properties || [];

  const customer = data.customer || {};
  const subscription = data.subscription || {};
  const portfolio = data.portfolio || {};
  const credits = data.credits || {};
  const trial = data.trial || {};

  const isTrial =
    subscription.is_trial === true &&
    trial.active === true;

  const basePlanName =
    subscription.base_plan ||
    subscription.plan ||
    "Free";

  const trialCreditsRemaining =
    Number(trial.credits_remaining ?? 0);

  const trialCreditsUsed =
    Number(trial.credits_used ?? 0);

  const trialDaysRemaining =
    Math.max(
      0,
      Number(trial.days_remaining ?? 0)
    );

  const isUnlimitedCredits =
    credits.unlimited === true;

  const availableCreditsDisplay = String(
    credits.display ??
      (
        isUnlimitedCredits
          ? "Unlimited"
          : credits.available ?? 0
      )
  );

  const downloadsRemainingDisplay =
    isUnlimitedCredits
      ? "Unlimited"
      : String(
          subscription.downloads_remaining ?? 0
        );

  container.innerHTML = `
    <div class="dashboard-header">
      <h1>Dashboard</h1>

      <p>
        Welcome back${customer.first_name
          ? `, <strong>${escapeHtml(customer.first_name)}</strong>`
          : ""}
      </p>
    </div>

    <div class="dashboard-cards">
      <div class="dashboard-card">
        <div class="card-title">
          Current Plan
        </div>

        <div class="card-value">
          ${escapeHtml(
            basePlanName
          )}
        </div>

        <div class="card-subtitle">
          ${
            isTrial
              ? "Free account"
              : isUnlimitedCredits
                ? "Unlimited intelligence access"
                : `${escapeHtml(
                    availableCreditsDisplay
                  )} Intelligence Credits available`
          }
        </div>
      </div>

      <div class="dashboard-card">
        <div class="card-title">
          ${isTrial ? "Explorer Trial" : "Available Credits"}
        </div>

        <div class="card-value">
          ${escapeHtml(
            availableCreditsDisplay
          )}
        </div>

        <div class="card-subtitle">
          ${
            isTrial
              ? `${trialDaysRemaining} ${
                  trialDaysRemaining === 1
                    ? "day"
                    : "days"
                } remaining`
              : "Use credits for reports and premium intelligence"
          }
        </div>
      </div>

      <div class="dashboard-card">
        <div class="card-title">
          Saved Properties
        </div>

        <div class="card-value">
          ${Number(portfolio.total_saved) || 0}
        </div>

        <div class="card-subtitle">
          Investor Portfolio
        </div>
      </div>

      <div class="dashboard-card">
        <div class="card-title">
          Active Opportunities
        </div>

        <div class="card-value">
          ${Number(portfolio.accepting_proxy) || 0}
        </div>

        <div class="card-subtitle">
          Accepting Proxy
        </div>
      </div>

      <div class="dashboard-card">
        <div class="card-title">
          Estimated Portfolio
        </div>

        <div class="card-value">
          ${formatCompactMoney(
            portfolio.estimated_value
          )}
        </div>

        <div class="card-subtitle">
          Based on assessed values
        </div>
      </div>
    </div>

    <div class="dashboard-actions">
      <a
        href="/pages/properties"
        class="dashboard-explore-btn"
      >
        Explore Properties
      </a>

      <a
        href="/pages/subscription-plans"
        class="dashboard-upgrade-btn"
      >
        Upgrade Plan
      </a>
    </div>

    <div class="dashboard-section">
      <h2>Subscription Summary</h2>

      <div class="summary-grid">
        <div class="summary-item">
          <span>
            Current Plan
          </span>

          <strong>
            ${escapeHtml(
              basePlanName
            )}
          </strong>
        </div>

        <div class="summary-item">
          <span>${isTrial ? "Credits Used" : "Downloads Used"}</span>

          <strong>
            ${
              Number(
                subscription.downloads_used
              ) || 0
            }
          </strong>
        </div>

        <div class="summary-item">
          <span>${isTrial ? "Credits Remaining" : "Downloads Remaining"}</span>

          <strong>
            ${escapeHtml(
              downloadsRemainingDisplay
            )}
          </strong>
        </div>

        <div class="summary-item">
          <span>${isTrial ? "Trial Ends" : "Reset Date"}</span>

          <strong>
            ${
              subscription.reset_date
                ? escapeHtml(
                    formatDashboardDate(
                      subscription.reset_date
                    )
                  )
                : "Monthly"
            }
          </strong>
        </div>
      </div>
    </div>

    <div class="dashboard-section">
      <h2>Portfolio Summary</h2>

      <div class="portfolio-summary-grid">
        <div class="summary-card">
          <span>Saved Properties</span>

          <strong>
            ${Number(portfolio.total_saved) || 0}
          </strong>
        </div>

        <div class="summary-card">
          <span>Avg. Investment Score</span>

          <strong>
            ${safePercent(
              portfolio.average_score
            )}/100
          </strong>

          <div class="summary-score-bar">
            <div
              class="
                summary-score-fill
                ${getScoreClass(
                  portfolio.average_score
                )}
              "
              style="
                width:
                ${safePercent(
                  portfolio.average_score
                )}%
              "
            ></div>
          </div>
        </div>

        <div class="summary-card">
          <span>Upcoming Auctions</span>

          <strong>
            ${
              Number(
                portfolio.upcoming_auctions
              ) || 0
            }
          </strong>
        </div>

        <div class="summary-card">
          <span>Estimated Portfolio</span>

          <strong>
            ${formatCompactMoney(
              portfolio.estimated_value
            )}
          </strong>
        </div>
      </div>
    </div>

    <div class="dashboard-section">
      <h2>Saved Properties</h2>

      ${
        savedProperties.length === 0
          ? renderEmptyPortfolio()
          : renderSavedProperties(
              savedProperties
            )
      }
    </div>

    <div class="dashboard-section">
      <h2>Recent Downloads</h2>

      ${
        recentDownloads.length === 0
          ? `
              <p class="dashboard-empty">
                No downloads yet.
              </p>
            `
          : renderRecentDownloads(
              recentDownloads
            )
      }
    </div>
  `;
}

function renderEmptyPortfolio() {
  return `
    <div class="portfolio-empty">
      <div class="portfolio-empty-icon">
        🏠
      </div>

      <h3>No saved properties yet</h3>

      <p>
        Save properties from the catalog to build
        your investment portfolio.
      </p>

      <a
        href="/pages/properties"
        class="portfolio-empty-btn"
      >
        Browse Properties
      </a>
    </div>
  `;
}

function renderSavedProperties(
  savedProperties
) {
  return `
    <div class="portfolio-toolbar">
      <input
        id="portfolio-search"
        class="portfolio-search"
        type="text"
        placeholder="Search saved properties..."
      >

      <select id="portfolio-filter">
        <option value="all">
          All Properties
        </option>

        <option value="accepting proxy">
          Accepting Proxy
        </option>

        <option value="pre foreclosure">
          Pre Foreclosure
        </option>

        <option value="sold">
          Sold
        </option>
      </select>
    </div>

    <div class="portfolio-grid">
      ${savedProperties
        .map(renderPropertyCard)
        .join("")}
    </div>
  `;
}

function renderPropertyCard(property) {
  const caseNumber =
    String(property.CaseNumber || "");

  const address =
    property.Address ||
    "Address unavailable";

  const city =
    property.City || "";

  const zip =
    property.Zip || "";

  const status =
    property.CurrentStatus ||
    "Unknown";

  const score =
    safePercent(
      property.InvestmentScore
    );

  const propertyUrl =
    "/pages/property-details" +
    `?case_number=${
      encodeURIComponent(caseNumber)
    }`;

  return `
    <div class="portfolio-card">
      <div class="portfolio-image">
        <img
          src="${getPropertyImageUrl(property)}"
          alt="${escapeAttribute(address)}"
          loading="lazy"
          onerror="
            this.onerror=null;
            this.src='https://placehold.co/600x350?text=No+Image+Available';
          "
        >

        <span
          class="
            portfolio-status
            ${getStatusClass(status)}
          "
        >
          ${escapeHtml(status)}
        </span>
      </div>

      <div class="portfolio-body">
        <h3>
          ${escapeHtml(address)}
        </h3>

        <div class="portfolio-location">
          ${escapeHtml(city)},
          FL
          ${escapeHtml(zip)}
        </div>

        <div class="portfolio-score">
          <div class="score-card">
            <span>Investment Score</span>

            <strong>
              ${score}/100
            </strong>

            <div class="score-bar">
              <div
                class="
                  score-fill
                  ${getScoreClass(score)}
                "
                style="width:${score}%"
              ></div>
            </div>
          </div>

          <div class="score-card">
            <span>Opportunity</span>

            <strong
              class="${
                getOpportunityClass(
                  property.Opportunity
                )
              }"
            >
              ${escapeHtml(
                property.Opportunity ??
                  "N/A"
              )}
            </strong>
          </div>

          <div class="score-card">
            <span>Risk</span>

            <strong
              class="${
                getRiskClass(
                  property.RiskLevel
                )
              }"
            >
              ${escapeHtml(
                property.RiskLevel ??
                  "N/A"
              )}
            </strong>
          </div>
        </div>

        <div class="portfolio-specs">
          <span>
            🛏
            ${escapeHtml(
              cleanPropertyValue(
                property.Beds
              )
            )}
          </span>

          <span>
            🛁
            ${escapeHtml(
              cleanPropertyValue(
                property.Baths
              )
            )}
          </span>

          <span>
            📐
            ${escapeHtml(
              cleanPropertyValue(
                property.LotSize
              )
            )}
          </span>
        </div>

        <div class="portfolio-auction">
          <div>
            <strong>Auction Date</strong>

            <span>
              ${escapeHtml(
                formatDashboardDate(
                  property.SaleDate
                )
              )}
            </span>
          </div>

          <em
            class="${
              getAuctionUrgencyClass(
                property.DaysRemaining
              )
            }"
          >
            ${formatDaysRemaining(
              property.DaysRemaining
            )}
          </em>
        </div>

        ${renderAuctionTimeline(
          property.DaysRemaining
        )}

        <div class="portfolio-value-wrap">
          <div class="portfolio-value-label">
            Assessed Value
          </div>

          <div class="portfolio-value">
            ${escapeHtml(
              property.AssessedValue ??
                "N/A"
            )}
          </div>
        </div>

        <div class="portfolio-actions">
          <a
            href="${propertyUrl}"
            class="portfolio-btn primary"
          >
            View Property
          </a>

          <a
            href="${propertyUrl}#documents"
            class="portfolio-btn"
          >
            Documents
          </a>

          <button
            class="
              portfolio-btn
              danger
              remove-saved-property
            "
            data-case="${
              escapeAttribute(caseNumber)
            }"
            type="button"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  `;
}

function renderRecentDownloads(
  recentDownloads
) {
  return `
    <div class="download-cards">
      ${recentDownloads
        .map(renderDownloadCard)
        .join("")}
    </div>
  `;
}

function renderDownloadCard(download) {
  const caseNumber =
    String(download.CaseNumber || "");

  const documentType =
    String(download.DocumentType || "");

  return `
    <div class="download-card">
      <div class="download-icon">
        📄
      </div>

      <div class="download-info">
        <h3>
          ${escapeHtml(
            formatDocumentType(
              documentType
            )
          )}
        </h3>

        <p>
          ${escapeHtml(caseNumber)}
        </p>

        <span>
          ${escapeHtml(
            formatDownloadDate(
              download.DownloadDate
            )
          )}
        </span>
      </div>

      <button
        class="
          download-again-btn
          dashboard-download-btn
        "
        data-case-number="${
          escapeAttribute(caseNumber)
        }"
        data-document-type="${
          escapeAttribute(documentType)
        }"
        type="button"
      >
        Download
      </button>
    </div>
  `;
}

function getPropertyImageUrl(property) {
  if (
    !property ||
    !property.Lat ||
    !property.Lon
  ) {
    return (
      "https://placehold.co/" +
      "600x350?text=No+Image+Available"
    );
  }

  const latitude =
    encodeURIComponent(property.Lat);

  const longitude =
    encodeURIComponent(property.Lon);

  return (
    "https://api.goprovalo.com/" +
    "streetview.php" +
    `?lat=${latitude}` +
    `&lon=${longitude}`
  );
}

function formatDocumentType(type) {
  const labels = {
    appraiser: "Appraiser",
    complaint: "Complaint",
    lispendens: "Lis Pendens",
    tax: "Tax",
    property_report:
      "Due Diligence Report"
  };

  return (
    labels[type] ||
    type ||
    "Document"
  );
}

function formatDashboardDate(dateValue) {
  if (!dateValue) return "N/A";

  const value =
    String(dateValue).trim();

  const dateOnlyMatch =
    value.match(
      /^(\d{4})-(\d{2})-(\d{2})$/
    );

  if (dateOnlyMatch) {
    const [
      ,
      year,
      month,
      day
    ] = dateOnlyMatch;

    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );

    return date.toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "short",
        day: "numeric"
      }
    );
  }

  const date = new Date(
    value.replace(" ", "T")
  );

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleDateString(
    "en-US",
    {
      year: "numeric",
      month: "short",
      day: "numeric"
    }
  );
}

function formatDownloadDate(dateValue) {
  if (!dateValue) return "N/A";

  const value =
    String(dateValue).trim();

  const match = value.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/
  );

  if (!match) {
    return value;
  }

  const [
    ,
    year,
    month,
    day,
    hour,
    minute,
    second
  ] = match;

  const date = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second)
  );

  return date.toLocaleString(
    "en-US",
    {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    }
  );
}

function getGoProvaloCookie(cookieName) {
  const cookiePrefix = `${encodeURIComponent(cookieName)}=`;

  const matchingCookie = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(cookiePrefix));

  if (!matchingCookie) {
    return "";
  }

  return decodeURIComponent(
    matchingCookie.substring(cookiePrefix.length)
  );
}

function getGoProvaloCsrfToken() {
  return getGoProvaloCookie(
    "goprovalo_customer_session_csrf"
  );
}

function showDashboardMessage(
  title,
  message,
  action = null
) {
  const modal =
    document.getElementById(
      "dashboard-message-modal"
    );

  const titleElement =
    document.getElementById(
      "dashboard-message-title"
    );

  const messageElement =
    document.getElementById(
      "dashboard-message-text"
    );

  const upgradeButton =
    document.getElementById(
      "dashboard-message-upgrade"
    );

  if (
    !modal ||
    !titleElement ||
    !messageElement ||
    !upgradeButton
  ) {
    console.error(
      title,
      message
    );
    return;
  }

  titleElement.textContent =
    String(title || "Notice");

  messageElement.textContent =
    String(
      message ||
      "Please try again."
    );

  if (action === "upgrade") {
    upgradeButton.classList.remove(
      "hidden"
    );
  } else {
    upgradeButton.classList.add(
      "hidden"
    );
  }

  modal.classList.remove("hidden");
}

function formatDaysRemaining(days) {
  if (
    days === null ||
    days === undefined
  ) {
    return "Auction passed";
  }

  const numericDays = Number(days);

  if (!Number.isFinite(numericDays)) {
    return "Auction date unavailable";
  }

  const normalizedDays =
    Math.max(
      0,
      Math.round(numericDays)
    );

  if (normalizedDays === 0) {
    return "Auction today";
  }

  if (normalizedDays === 1) {
    return "1 day remaining";
  }

  return `${normalizedDays} days remaining`;
}

function renderAuctionTimeline(days) {
  if (
    days === null ||
    days === undefined
  ) {
    return `
      <div class="auction-timeline muted">
        <div class="auction-line"></div>

        <div class="auction-timeline-labels">
          <span>Today</span>
          <span>Auction Passed</span>
        </div>
      </div>
    `;
  }

  const numericDays = Number(days);

  if (!Number.isFinite(numericDays)) {
    return "";
  }

  const normalizedDays =
    Math.max(
      0,
      Math.round(numericDays)
    );

  const percent =
    Math.max(
      0,
      Math.min(
        100,
        100 - normalizedDays
      )
    );

  return `
    <div class="auction-timeline">
      <div class="auction-line">
        <div
          class="auction-progress"
          style="width:${percent}%"
        ></div>
      </div>

      <div class="auction-timeline-labels">
        <span>Today</span>

        <span>
          ${normalizedDays} days left
        </span>
      </div>
    </div>
  `;
}

function getAuctionUrgencyClass(days) {
  if (
    days === null ||
    days === undefined
  ) {
    return "auction-muted";
  }

  const numericDays = Number(days);

  if (!Number.isFinite(numericDays)) {
    return "auction-muted";
  }

  if (numericDays <= 3) {
    return "auction-critical";
  }

  if (numericDays <= 14) {
    return "auction-warning";
  }

  return "auction-safe";
}

function getStatusClass(status) {
  const value =
    String(status || "").toLowerCase();

  if (
    value.includes("accepting proxy")
  ) {
    return "status-accepting";
  }

  if (value.includes("sold")) {
    return "status-sold";
  }

  if (value.includes("cancel")) {
    return "status-canceled";
  }

  if (
    value.includes("pre foreclosure")
  ) {
    return "status-preforeclosure";
  }

  return "status-default";
}

function formatCompactMoney(value) {
  const number = Number(value) || 0;

  if (number >= 1000000) {
    return (
      `$${(
        number / 1000000
      ).toFixed(1)}M`
    );
  }

  if (number >= 1000) {
    return (
      `$${Math.round(
        number / 1000
      )}K`
    );
  }

  return `$${number}`;
}

function cleanPropertyValue(value) {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === "-1" ||
    Number(value) === -1
  ) {
    return "N/A";
  }

  return value;
}

function safePercent(value) {
  const number = Number(value);

  if (!Number.isFinite(number)) {
    return 0;
  }

  return Math.max(
    0,
    Math.min(
      100,
      Math.round(number)
    )
  );
}

function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function escapeAttribute(value) {
  return escapeHtml(value);
}

function getOpportunityClass(
  opportunity
) {
  const value =
    String(
      opportunity || ""
    ).toLowerCase();

  if (value === "excellent") {
    return "opportunity-excellent";
  }

  if (value === "high") {
    return "opportunity-high";
  }

  if (value === "medium") {
    return "opportunity-medium";
  }

  if (value === "low") {
    return "opportunity-low";
  }

  return "";
}

function getRiskClass(risk) {
  const value =
    String(risk || "").toLowerCase();

  if (value === "low") {
    return "risk-low";
  }

  if (value === "medium") {
    return "risk-medium";
  }

  if (value === "high") {
    return "risk-high";
  }

  return "";
}

function getScoreClass(score) {
  const normalizedScore =
    safePercent(score);

  if (normalizedScore >= 90) {
    return "score-excellent";
  }

  if (normalizedScore >= 75) {
    return "score-high";
  }

  if (normalizedScore >= 60) {
    return "score-medium";
  }

  return "score-low";
}

document.addEventListener(
  "click",
  async function (event) {
    const button =
      event.target.closest(
        ".remove-saved-property"
      );

    if (!button) return;

    const caseNumber =
      button.dataset.case;

    if (!caseNumber) return;

    const originalText =
      button.textContent;

    button.disabled = true;
    button.textContent = "Removing...";

    try {
      const response = await fetch(
        "https://api.goprovalo.com/update_wishlist.php",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": getGoProvaloCsrfToken()
          },
          body: JSON.stringify({
            case_number: caseNumber,
            action: "remove",
          })
        }
      );

      const responseText =
        await response.text();

      let result;

      try {
        result =
          JSON.parse(responseText);
      } catch (error) {
        console.error(
          "Invalid wishlist API response:",
          responseText
        );

        throw new Error(
          "The wishlist service returned an invalid response."
        );
      }

      if (
        !response.ok ||
        !result.success
      ) {
        showDashboardMessage(
          "Unable to remove property",
          result.message ||
            "Please try again later."
        );
        return;
      }

      let items = [];

      try {
        const storedItems =
          JSON.parse(
            localStorage.getItem(
              "goprovalo_wishlist"
            )
          );

        if (Array.isArray(storedItems)) {
          items = storedItems;
        }
      } catch (error) {
        console.warn(
          "Unable to read the local wishlist:",
          error
        );
      }

      const updatedItems =
        items.filter(
          item =>
            String(item) !==
            String(caseNumber)
        );

      localStorage.setItem(
        "goprovalo_wishlist",
        JSON.stringify(updatedItems)
      );

      await loadDashboard();
    } catch (error) {
      console.error(
        "Wishlist removal error:",
        error
      );

      showDashboardMessage(
        "Unable to remove property",
        "Please try again later."
      );
    } finally {
      button.disabled = false;
      button.textContent =
        originalText || "Remove";
    }
  }
);

document
  .getElementById(
    "dashboard-message-close"
  )
  ?.addEventListener(
    "click",
    function () {
      document
        .getElementById(
          "dashboard-message-modal"
        )
        ?.classList.add("hidden");
    }
  );

document
  .getElementById(
    "dashboard-message-upgrade"
  )
  ?.addEventListener(
    "click",
    function () {
      window.location.href =
        "/pages/subscription-plans";
    }
  );

document.addEventListener(
  "click",
  async function (event) {
    const button =
      event.target.closest(
        ".dashboard-download-btn"
      );

    if (!button) return;

    const caseNumber =
      button.dataset.caseNumber;

    const documentType =
      button.dataset.documentType;

    if (
      !caseNumber ||
      !documentType
    ) {
      showDashboardMessage(
        "Unable to download document",
        "The document information is incomplete."
      );
      return;
    }

    const checkUrl =
      "https://api.goprovalo.com/" +
      "check_download_access.php" +
      `?case_number=${
        encodeURIComponent(caseNumber)
      }` +
      `&type=${
        encodeURIComponent(documentType)
      }`;

    const originalText =
      button.textContent;

    button.disabled = true;
    button.textContent = "Checking...";

    try {
      const response =
        await fetch(
          checkUrl,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type":
                "application/json"
            },
            body: JSON.stringify({
              customer:
                window.GoProvaloCustomer ||
                null
            })
          }
        );

      const responseText =
        await response.text();

      let result;

      try {
        result =
          JSON.parse(responseText);
      } catch (error) {
        console.error(
          "Invalid download API response:",
          responseText
        );

        throw new Error(
          "The download service returned an invalid response."
        );
      }

      if (
        !response.ok ||
        !result.success
      ) {
        showDashboardMessage(
          result.title ||
            "Unable to download document",
          result.message ||
            "Please try again later.",
          result.action || null
        );
        return;
      }

      if (!result.download_url) {
        showDashboardMessage(
          "Unable to download document",
          "The server did not return a download link."
        );
        return;
      }

      window.open(
        result.download_url,
        "_blank",
        "noopener"
      );
    } catch (error) {
      console.error(
        "Dashboard download error:",
        error
      );

      showDashboardMessage(
        "Connection Error",
        "Unable to verify download access. Please try again later."
      );
    } finally {
      button.disabled = false;
      button.textContent =
        originalText || "Download";
    }
  }
);

document.addEventListener(
  "input",
  filterPortfolio
);

document.addEventListener(
  "change",
  filterPortfolio
);

function filterPortfolio() {
  const search =
    (
      document.getElementById(
        "portfolio-search"
      )?.value || ""
    )
      .trim()
      .toLowerCase();

  const status =
    (
      document.getElementById(
        "portfolio-filter"
      )?.value || "all"
    )
      .trim()
      .toLowerCase();

  document
    .querySelectorAll(
      ".portfolio-card"
    )
    .forEach(card => {
      const text =
        card.textContent
          .toLowerCase();

      const showSearch =
        text.includes(search);

      const showStatus =
        status === "all" ||
        text.includes(status);

      card.style.display =
        showSearch && showStatus
          ? ""
          : "none";
    });
}

if (
  document.readyState === "loading"
) {
  document.addEventListener(
    "DOMContentLoaded",
    loadDashboard,
    {
      once: true
    }
  );
} else {
  loadDashboard();
}

function getGoProvaloCookie(cookieName) {
  const prefix = `${encodeURIComponent(cookieName)}=`;

  const cookie = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  if (!cookie) {
    return "";
  }

  return decodeURIComponent(
    cookie.substring(prefix.length)
  );
}

async function logoutGoProvaloCustomer() {
  /*
   * This must match:
   *
   * session_cookie_name + "_csrf"
   *
   * in /private/goprovalo_shopify.php.
   *
   * If session_cookie_name is "goprovalo_customer_session",
   * the CSRF cookie is "goprovalo_customer_session_csrf".
   */
  const csrfToken = getGoProvaloCookie(
    "goprovalo_customer_session_csrf"
  );

  try {
    const response = await fetch(
      "https://api.goprovalo.com/auth/customer_logout.php",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({})
      }
    );

    const responseText = await response.text();
    let result;

    try {
      result = JSON.parse(responseText);
    } catch (error) {
      throw new Error(
        "The logout service returned an invalid response."
      );
    }

    if (!response.ok || !result.success) {
      throw new Error(
        result.message || "Unable to sign out."
      );
    }

    window.location.href = "/";
  } catch (error) {
    console.error("Customer logout error:", error);

    showDashboardMessage(
      "Unable to sign out",
      error.message || "Please try again."
    );
  }
}

document.addEventListener("click", function (event) {
  const logoutButton = event.target.closest(
    "[data-goprovalo-logout]"
  );

  if (!logoutButton) {
    return;
  }

  event.preventDefault();
  logoutGoProvaloCustomer();
});